import React from 'react';

import {
    StyledSVG,
    StyledSVGWrapper,
} from './svg-image.style'


interface SVGProps {
    src: string;
    color?: string;
    className?: string;
    alt?: string;
    iconSize?: string;
    lazyIcon?: boolean;
    doDarken?: boolean;
}

function darkenHexColor(hex: string, amount = 130) {
    // Convert hex to RGB
    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);

    // Decrease the brightness
    r = Math.max(0, r - amount);
    g = Math.max(0, g - amount);
    b = Math.max(0, b - amount);

    // Convert RGB back to hex
    return "#" + [r, g, b].map(x => {
        const hex = x.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
    }).join("");
}


const SVGImage: React.FunctionComponent<SVGProps> = ({
                                                         src = '',
                                                         color = undefined,
                                                         alt = "post preview",
                                                         iconSize = "50%",
                                                         doDarken = false,
                                                         // lazyIcon = false,
                                                     }) => {
    // const [isLoaded, setIsLoaded] = useState(false);

    // const handleImageLoaded = () => {
    //   setIsLoaded(true);
    // };

    const isIcon = src.endsWith('icon.svg');

    let background = {};
    if (color && doDarken) {
        const darker_color = darkenHexColor(`${color}`, 25);
        background = {backgroundImage: `linear-gradient(${darker_color}, ${color})`}
    } else if (color) {
        background = {backgroundColor: color}
    }
    return (
        <StyledSVGWrapper
            // style={color !== undefined ? { backgroundImage: `url('/grain.webp'), linear-gradient(${darker_color}, ${color})` } : {}}
            style={background}
            // style={color !== undefined ? { backgroundColor: `${color}` } : {}}
            className="svg-wrapper"
        >
            {src === '' ?
                (<></>
                ) : (
                    <StyledSVG
                        // onLoad={handleImageLoaded}
                        // loading={lazyIcon && isIcon ? "lazy" : undefined}
                        // className={`${isIcon ? 'icon' : 'cover'} ${isLoaded ? 'loaded' : ''}`}
                        className={`${isIcon ? 'icon' : 'cover'}`}
                        style={{
                            width: isIcon ? iconSize : '100%',
                            // opacity: lazyIcon && isIcon && !isLoaded ? 0 : 1
                            // opacity: lazyIcon && isIcon && !isLoaded ? 0 : 1
                        }}
                        src={src}
                        alt={alt}
                    />
                )
            }
        </StyledSVGWrapper>
    );
};

export default SVGImage;
